// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionLogo_container__2aNhd","title":"SectionLogo_title__zhBk4","imageContainer":"SectionLogo_imageContainer__3AI8r","mainImage":"SectionLogo_mainImage__1Qgol"};